import { useTranslation } from 'react-i18next';

import type { SocialPostStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const TONES: Record<SocialPostStatus, string> = {
  draft: 'border-border text-muted-foreground',
  scheduled: 'bg-primary/10 text-primary dark:bg-primary/20 border-transparent',
  publishing: 'bg-primary/10 text-primary dark:bg-primary/20 border-transparent',
  published: 'bg-success/15 text-success dark:bg-success/20 border-transparent',
  failed: 'bg-destructive/10 text-destructive dark:bg-destructive/20 border-transparent',
  removed: 'border-border text-muted-foreground line-through',
};

export function PostStatusBadge({ status }: { status: SocialPostStatus }) {
  const { t } = useTranslation('social');
  return (
    <Badge variant="outline" className={cn(TONES[status])} data-status={status}>
      {t(`postStatus.${status}`)}
    </Badge>
  );
}
